export default __webpack_public_path__ + "static/media/file-download-disabled.b128ced2.svg";